module.exports = __webpack_public_path__ + "img/3000m.814a0111.png";